import { Injectable } from '@angular/core';
import { collection, doc, Firestore, getDoc, setDoc } from '@angular/fire/firestore';
import { Comment } from '../models/comment';

@Injectable()
export class CommentService {
  constructor(
    private firestore: Firestore
  ) {}

  async createOrUpdateAsync(sectionId: string, reportId: string, studentId: string, comment: string) {
    const commentCollectionRef = doc(this.firestore, `comments/${sectionId}-${reportId}-${studentId}`);

    await setDoc(commentCollectionRef, {
      sectionId: sectionId,
      reportId: reportId,
      studentId: studentId,
      text: comment,
    });
  }


  async readAsync(sectionId: string, reportId: string, studentId: string): Promise<Comment> {
    const commentDocRef = doc(this.firestore, `comments/${sectionId}-${reportId}-${studentId}`);

    const commentSnapshot = await getDoc(commentDocRef);

    if (commentSnapshot.exists()) {
      console.debug('Fetched comment readAsync:', commentSnapshot.data());
      return commentSnapshot.data() as Comment;
    } else {
      console.debug('no comment found for sectionId:', sectionId, 'reportId:', reportId, 'studentId:', studentId);
      return new Comment(); // Return an empty comment if it does not exist
    }

  }

}
